import React from 'react';
import PropTypes from 'prop-types';

import Message from '../Message';

import { Header } from './components';
import './Title.scss';

const Title = ({ size = '2', message, children, font, testId, className }) => {
  const titleClass = `title-wrapper${className ? ` ${className}` : ''}`;

  return (
    <div data-testid={testId} className={titleClass}>
      <Header className="title-message" size={size} font={font}>
        <Message message={message} />
      </Header>
      <div className="title-content">
        {children}
      </div>
    </div>
  );
};

Title.propTypes = {
  message: PropTypes.object,
  size: PropTypes.string.isRequired,
  children: PropTypes.node,
  font: PropTypes.string,
  testId: PropTypes.string,
  className: PropTypes.string,
};

export default Title;
